import script from "./AccordionRecurring.vue?vue&type=script&setup=true&lang=js"
export * from "./AccordionRecurring.vue?vue&type=script&setup=true&lang=js"

import "./AccordionRecurring.vue?vue&type=style&index=0&id=0e18c2bd&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e18c2bd"]])

export default __exports__